"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));
var _mobx = require("mobx");
var _asyncSearchResults = _interopRequireDefault(require("../api/async-search-results.store"));
var _marketingBanners = _interopRequireDefault(require("../api/marketing-banners.store"));
var _topAirlines = _interopRequireDefault(require("../api/top-airlines.store"));
var _domesticSearchResults = _interopRequireDefault(require("../domestic-search-results.store"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _search = _interopRequireDefault(require("../../utils/search.utils"));
var _combinedItinerary = _interopRequireDefault(require("../../factories/combined-itinerary.factory"));
var _constants = require("../../constants");
var _dec, _dec2, _dec3, _class, _descriptor;
var FlightsDomesticSearchPageStore = exports.default = (_dec = _mobx.action.bound, _dec2 = _mobx.action.bound, _dec3 = _mobx.action.bound, (_class = function () {
  function FlightsDomesticSearchPageStore(initialState, $env) {
    if (initialState === void 0) {
      initialState = {};
    }
    (0, _classCallCheck2.default)(this, FlightsDomesticSearchPageStore);
    (0, _initializerDefineProperty2.default)(this, "searchQuery", _descriptor, this);
    this.$env = $env;
    this.searchResults = new _asyncSearchResults.default(initialState.searchResults, $env);
    this.marketingBanners = new _marketingBanners.default(initialState.marketingBanners, $env);
    this.topAirlines = new _topAirlines.default(initialState.topAirlines, $env);
    this.outbound = new _domesticSearchResults.default({
      direction: _constants.OUTBOUND,
      searchResults: this.searchResults,
      topAirlines: this.topAirlines
    }, $env);
    this.inbound = new _domesticSearchResults.default({
      direction: _constants.INBOUND,
      searchResults: this.searchResults,
      topAirlines: this.topAirlines
    }, $env);
  }
  (0, _createClass2.default)(FlightsDomesticSearchPageStore, [{
    key: "hasNoResults",
    get: function get() {
      return this.searchResults.hasError || this.searchResults.isCompleted && !this.searchResults.itineraries.length;
    }
  }, {
    key: "searchRoute",
    get: function get() {
      return _search.default.getRouteFromQuery(this.searchResults.searchQuery);
    }
  }, {
    key: "marketingCampaigns",
    get: function get() {
      var isDomesticKSA = this.searchResults.searchRequest.isDomesticKSA;
      var searchType = this.searchResults.searchRequest.searchType;
      return this.marketingBanners.getValidCampaigns({
        route: this.searchRoute,
        airlines: this.searchResults.airlineCodes,
        searchType: searchType,
        isDomesticKSA: isDomesticKSA
      });
    }
  }, {
    key: "topCampaign",
    get: function get() {
      var isDomesticKSA = this.searchResults.searchRequest.isDomesticKSA;
      var searchType = this.searchResults.searchRequest.searchType;
      return this.marketingBanners.topCampaign({
        route: this.searchRoute,
        airlines: this.searchResults.airlineCodes,
        searchType: searchType,
        isDomesticKSA: isDomesticKSA
      });
    }
  }, {
    key: "isInboundMatchOutbound",
    get: function get() {
      var outboundGroupId = this.outbound.selectedFlightGroupId;
      var inboundGroupId = this.inbound.selectedFlightGroupId;
      return outboundGroupId && inboundGroupId && outboundGroupId === inboundGroupId;
    }
  }, {
    key: "combinedSelectedFlight",
    get: function get() {
      return (0, _combinedItinerary.default)({
        outbound: this.outbound.selectedFlight,
        inbound: this.inbound.selectedFlight,
        $currency: this.$env.currency
      });
    }
  }, {
    key: "parsedSearchQuery",
    get: function get() {
      return _search.default.getParsedSearchQuery(this.searchQuery);
    }
  }, {
    key: "extraBaggageSearch",
    get: function get() {
      var searchRequest = this.searchResults.searchRequest;
      var originId = (0, _get2.default)(searchRequest, 'originId');
      var destinationId = (0, _get2.default)(searchRequest, 'destinationId');
      return originId + "-" + destinationId + "," + destinationId + "-" + originId;
    }
  }, {
    key: "isExtraBaggageEnabled",
    get: function get() {
      var isEconomy = _search.default.checkEconomyCabin(this.searchQuery);
      var isAlmosafer = this.$env.config.isAlmosafer;
      return isAlmosafer && isEconomy;
    }
  }, {
    key: "setSelectedFlight",
    value: function setSelectedFlight(itineraryId, direction) {
      if (_constants.FLIGHT_DIRECTIONS.includes(direction)) {
        this[direction].setSelectedFlightId(itineraryId);
      }
      if (direction === _constants.OUTBOUND) {
        this.inbound.outboundFlightId = itineraryId;
      }
    }
  }, {
    key: "setSelectedExtraBaggageOption",
    value: function setSelectedExtraBaggageOption(option, direction) {
      if (_constants.FLIGHT_DIRECTIONS.includes(direction)) {
        this[direction].setSelectedExtraBaggage(option);
      }
      if (direction === _constants.OUTBOUND) {
        this.inbound.outboundExtraBaggageOption = option;
      }
    }
  }, {
    key: "setSearchQuery",
    value: function setSearchQuery(query) {
      this.searchQuery = query;
    }
  }]);
  return FlightsDomesticSearchPageStore;
}(), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "searchQuery", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasNoResults", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasNoResults"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "searchRoute", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "searchRoute"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "marketingCampaigns", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "marketingCampaigns"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "topCampaign", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "topCampaign"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isInboundMatchOutbound", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isInboundMatchOutbound"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "combinedSelectedFlight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "combinedSelectedFlight"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "parsedSearchQuery", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "parsedSearchQuery"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "extraBaggageSearch", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "extraBaggageSearch"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isExtraBaggageEnabled", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isExtraBaggageEnabled"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "setSelectedFlight", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "setSelectedFlight"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "setSelectedExtraBaggageOption", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "setSelectedExtraBaggageOption"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "setSearchQuery", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "setSearchQuery"), _class.prototype)), _class));